module.exports = __webpack_public_path__ + "static/img/carton.d374cfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/package-service/carton.png
// module id = sCu6
// module chunks = 2